import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from "react-icons/io";
import { Mousewheel, Navigation, Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss/scrollbar";
import { Product } from "../../../../../../graphql/operations";
import { Text } from "../../../../../Atoms/Typography";
import GuideAvatarProfile from "../../../../../Cards/GuideAvatarProfile";
import styles from "./AvailableGuidesCarousel.module.scss";

export type AvailableGuidesCarouselProps = {
  title: string;
  product: Pick<Product, "id">;
  availableGuides: {
    productAvailability: { date: string };
    timeSlot: { time: string };
    guide?: {
      id: string;
      nickName: string;
      profilePic: string;
      introVideo: string;
      numTours: number;
      numCustomers: number;
      translation: { description: string };
    };
  }[];
};

export default function AvailableGuidesCarousel({
  availableGuides,
  product,
  title,
}: AvailableGuidesCarouselProps) {
  return (
    <>
      <div className={styles.guidesSwiperHeader}>
        <Text size="normal" bold>
          {title}
        </Text>
        <div className={styles.guideSwiperButtons}>
          <div className="guideSwiperButtonPrev">
            <IoIosArrowDropleftCircle color={"rgb(233 30 99)"} size={34} />
          </div>
          <div className="guideSwiperButtonNext">
            <IoIosArrowDroprightCircle color={"rgb(233 30 99)"} size={34} />
          </div>
        </div>
      </div>
      <Swiper
        style={{ paddingBottom: 15 }}
        scrollbar={{
          el: ".swiper-scrollbar",
          draggable: true,
          dragSize: 50,
        }}
        effect="slide"
        slidesPerView={2.5}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          400: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 1.2,
            spaceBetween: 20,
          },

          640: {
            slidesPerView: 2.2,
          },
          767: {
            slidesPerView: 2.5,
          },
        }}
        freeMode={true}
        cssMode={true}
        navigation={{
          nextEl: ".guideSwiperButtonNext",
          prevEl: ".guideSwiperButtonPrev",
        }}
        mousewheel={{
          sensitivity: 1,
          releaseOnEdges: true,
        }}
        modules={[Mousewheel, Navigation, Scrollbar]}
        spaceBetween={40}
      >
        {availableGuides.map((g, index) => {
          return (
            <SwiperSlide key={index}>
              <GuideAvatarProfile {...g} product={product} />
            </SwiperSlide>
          );
        })}
        <div className="swiper-scrollbar" />
      </Swiper>
    </>
  );
}
